import { useQuery } from '@tanstack/react-query';
import api from '../utils/axios.ts';

export function useFeatures() {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['features'],
    queryFn: async () => {
      try {
        console.log('[useFeatures] Fetching features...');
        const response = await api.get('/plans/current-group/features');
        console.log('[useFeatures] API response:', response.data);

        const upgradeAmount = response.data?.upgrade_amount;
        const renewalAmount = response.data?.renewal_amount;
        const currentPlanId = response.data?.plan_id;
        const currentPlanName = response.data?.name;
        const advancedPlanId = response.data?.advanced_plan_id;

        const meta = { upgradeAmount, renewalAmount, currentPlanId, currentPlanName, advancedPlanId };

        if (response.data && response.data.data) {
          const features = response.data.data.map((f) => f.name);
          console.log('[useFeatures] Parsed features:', features, meta);
          return { features, ...meta };
        } else {
          console.log('[useFeatures] No features data in response');
          return { features: [], ...meta };
        }
      } catch (error) {
        console.error('[useFeatures] Error fetching features:', error);
        // Return empty array on error to prevent breaking the UI
        return { features: [], upgradeAmount: undefined, renewalAmount: undefined, currentPlanId: undefined, currentPlanName: undefined, advancedPlanId: undefined };
      }
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
    retry: 2,
    retryDelay: 1000,
  });

  const featuresArray = data?.features || [];

  return {
    features: featuresArray,
    upgradeAmount: data?.upgradeAmount,
    renewalAmount: data?.renewalAmount,
    currentPlanId: data?.currentPlanId,
    currentPlanName: data?.currentPlanName,
    advancedPlanId: data?.advancedPlanId,
    isLoading,
    error: error?.message || null,
    refetch,
  };
}